import { render, staticRenderFns } from "./Charities.vue?vue&type=template&id=f0f20454&scoped=true&"
import script from "./Charities.vue?vue&type=script&lang=js&"
export * from "./Charities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f20454",
  null
  
)

export default component.exports